/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const AgencyProject = {

	delete (context, agencyProjectId, onSuccess, onError, options) {
		Api.delete(context,
			"/agencyProject"
			+ "?agencyProjectId=" + agencyProjectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	deleteSignedReportFile (context, projectId, onSuccess, onError, options) {
		Api.delete(context,
			"/agencyProject/signed-report-file"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAgencyEmail (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/agency-email"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAgencyProjectList (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/agency-project-list"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAgencyProjectsContestNames (context, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/agency-projects-contest-names"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAgencyProjectsCorrectionCauses (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/agency-projects-correction-causes"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAllAgencyProjectsCorrectionCauses (context, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/all-agency-projects-correction-causes"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAllContestNames (context, onlyMine, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/all-contest-names"
			+ "?onlyMine=" + onlyMine
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAllowedBasicData (context, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/allowed-basic-data"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAmounts (context, agencyProjectId, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/amounts"
			+ "?agencyProjectId=" + agencyProjectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAnnulationCause (context, agencyProjectId, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/annulation-cause"
			+ "?agencyProjectId=" + agencyProjectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getApprovedProjectsByAgency (context, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/approved-projects-by-agency"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getApprovedProjectsByContest (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/approved-projects-by-contest"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBasicData (context, agencyProjectId, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/basic-data"
			+ "?agencyProjectId=" + agencyProjectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBasicDataByCode (context, code, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/basic-data-by-code"
			+ "?code=" + code
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBasicDataList (context, ids, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/basic-data-list"
			+ "?ids=" + ids
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getCompareData (context, agencyProjectId, firstVersion, secondVersion, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/compare-data"
			+ "?agencyProjectId=" + agencyProjectId
			+ "&firstVersion=" + firstVersion
			+ "&secondVersion=" + secondVersion
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getCorrectionHistory (context, agencyProjectId, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/correction-history"
			+ "?agencyProjectId=" + agencyProjectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getCurrencyCode (context, agencyProjectId, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/currency-code"
			+ "?agencyProjectId=" + agencyProjectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getData (context, agencyProjectId, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/data"
			+ "?agencyProjectId=" + agencyProjectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDataReadonly (context, agencyProjectId, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/data-readonly"
			+ "?agencyProjectId=" + agencyProjectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDataVersion (context, agencyProjectId, version, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/data-version"
			+ "?agencyProjectId=" + agencyProjectId
			+ "&version=" + version
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getIsSupervisor (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/is-supervisor"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getPanelPermissionsForUser (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/panel-permissions-for-user"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getProjectAgencyData (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/project-agency-data"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSignedReportFile (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/signed-report-file"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getStatus (context, agencyProjectId, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/status"
			+ "?agencyProjectId=" + agencyProjectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSubmittedProjectList (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/submitted-project-list"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSubmittedProjectsCorrectionCauses (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/submitted-projects-correction-causes"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSummaryMainData (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/summary-main-data"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSummaryTasksData (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/summary-tasks-data"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSummaryUsersData (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/summary-users-data"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getUserDepartmentProjectStatus (context, agencyProjectId, onSuccess, onError, options) {
		Api.get(context,
			"/agencyProject/user-department-project-status"
			+ "?agencyProjectId=" + agencyProjectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, createAgencyProjectDto, onSuccess, onError, options) {
		Api.post(context,
			"/agencyProject"
			, createAgencyProjectDto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postAgencyProjectSupervisor (context, projectId, supervisorId, onSuccess, onError, options) {
		Api.post(context,
			"/agencyProject/agency-project-supervisor"
			+ "?projectId=" + projectId
			+ "&supervisorId=" + supervisorId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postReject (context, agencyProjectId, rejectCauseDTO, onSuccess, onError, options) {
		Api.post(context,
			"/agencyProject/reject"
			+ "?agencyProjectId=" + agencyProjectId
			, rejectCauseDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postRestore (context, agencyProjectId, onSuccess, onError, options) {
		Api.post(context,
			"/agencyProject/restore"
			+ "?agencyProjectId=" + agencyProjectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postSignedReportFile (context, projectId, fileToUpload, onSuccess, onError, options) {
		Api.post(context,
			"/agencyProject/signed-report-file"
			+ "?projectId=" + projectId
			+ "&fileToUpload=" + fileToUpload
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postSubmit (context, agencyProjectId, agencyProjectData, onSuccess, onError, options) {
		Api.post(context,
			"/agencyProject/submit"
			+ "?agencyProjectId=" + agencyProjectId
			, agencyProjectData
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, agencyProjectId, agencyProjectData, onSuccess, onError, options) {
		Api.put(context,
			"/agencyProject"
			+ "?agencyProjectId=" + agencyProjectId
			, agencyProjectData
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putAmountRemarks (context, projectId, remarksDTO, onSuccess, onError, options) {
		Api.put(context,
			"/agencyProject/amount-remarks"
			+ "?projectId=" + projectId
			, remarksDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putApprove (context, agencyProjectId, onSuccess, onError, options) {
		Api.put(context,
			"/agencyProject/approve"
			+ "?agencyProjectId=" + agencyProjectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putArchive (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/agencyProject/archive"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putCorrespondenceRemarks (context, projectId, remarksDTO, onSuccess, onError, options) {
		Api.put(context,
			"/agencyProject/correspondence-remarks"
			+ "?projectId=" + projectId
			, remarksDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putFinalReportRemarks (context, projectId, remarksDTO, onSuccess, onError, options) {
		Api.put(context,
			"/agencyProject/final-report-remarks"
			+ "?projectId=" + projectId
			, remarksDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putFinish (context, agencyProjectId, onSuccess, onError, options) {
		Api.put(context,
			"/agencyProject/finish"
			+ "?agencyProjectId=" + agencyProjectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putHide (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/agencyProject/hide"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putMonitoringRemarks (context, projectId, remarksDTO, onSuccess, onError, options) {
		Api.put(context,
			"/agencyProject/monitoring-remarks"
			+ "?projectId=" + projectId
			, remarksDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putOwnCurrency (context, agencyProjectId, ownCurrencyDTO, onSuccess, onError, options) {
		Api.put(context,
			"/agencyProject/own-currency"
			+ "?agencyProjectId=" + agencyProjectId
			, ownCurrencyDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putRequestAnnulation (context, agencyProjectId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/agencyProject/request-annulation"
			+ "?agencyProjectId=" + agencyProjectId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putRequestApprovedProjectCorrection (context, agencyProjectId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/agencyProject/request-approved-project-correction"
			+ "?agencyProjectId=" + agencyProjectId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putRequestCorrection (context, agencyProjectId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/agencyProject/request-correction"
			+ "?agencyProjectId=" + agencyProjectId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putSummaryDonation (context, agencyProjectId, donationDTO, onSuccess, onError, options) {
		Api.put(context,
			"/agencyProject/summary-donation"
			+ "?agencyProjectId=" + agencyProjectId
			, donationDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putUndoArchive (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/agencyProject/undo-archive"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putUndoFinish (context, agencyProjectId, onSuccess, onError, options) {
		Api.put(context,
			"/agencyProject/undo-finish"
			+ "?agencyProjectId=" + agencyProjectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putUndoHide (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/agencyProject/undo-hide"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putUndoRequestAnnulation (context, agencyProjectId, onSuccess, onError, options) {
		Api.put(context,
			"/agencyProject/undo-request-annulation"
			+ "?agencyProjectId=" + agencyProjectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putUndoRequestApprovedProjectCorrection (context, agencyProjectId, onSuccess, onError, options) {
		Api.put(context,
			"/agencyProject/undo-request-approved-project-correction"
			+ "?agencyProjectId=" + agencyProjectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putUndoRequestCorrection (context, agencyProjectId, onSuccess, onError, options) {
		Api.put(context,
			"/agencyProject/undo-request-correction"
			+ "?agencyProjectId=" + agencyProjectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
